exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".perf-tool .tab-manager{position:relative}.perf-tool .tab-bar{position:absolute;top:0;right:0;left:0;background-color:#f3f3f3;border-bottom:1px solid #ccc}.perf-tool .tab-header{display:inline-block;padding:.8em;font-size:12px;max-width:10em;width:100%;text-align:center;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;cursor:pointer;transition:all .2s ease-out;user-select:none;-webkit-user-select:none}.perf-tool .tab-header:hover{background-color:#e5e5e5;transition:all .2s ease-out}.perf-tool .tab-header.left{float:left}.perf-tool .tab-header.right{float:right}.perf-tool .tab-header.active{border-bottom:1px solid #3879d9}.perf-tool .tab{position:absolute;top:2.1em;right:0;bottom:0;left:0;height:100%}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/styles/tabs.css
 ** module id = 214
 ** module chunks = 0
 **/